import React from 'react';
import PropTypes from 'prop-types';
import { Fab } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CartMobileOptionsItem = ({
  color,
  size,
  icon,
  title,
  fabColor,
  disabled,
  onClick,
  disabledColor,
}) => (
  <div
    style={{ width: '22%' }}
    className="d-flex flex-column align-items-center mx-1"
  >
    <Fab
      disabled={disabled}
      onClick={onClick}
      style={{ backgroundColor: !disabled ? fabColor : disabledColor }}
    >
      <FontAwesomeIcon style={{ color }} size={size} icon={icon} />
    </Fab>
    <div
      style={{ maxWidth: '64px', height: '40px', lineHeight: '14px' }}
      className="mt-1 font-size-12 w-auto text-center"
    >
      {title}
    </div>
  </div>
);

CartMobileOptionsItem.propTypes = {
  icon: PropTypes.any,
  size: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string,
  fabColor: PropTypes.string,
  disabledColor: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

CartMobileOptionsItem.defaultProps = {
  icon: '',
  size: '2x',
  title: '',
  color: '#ffffff',
  fabColor: '#313C52',
  disabledColor: '#c6c6c6',
  disabled: false,
  onClick: () => {},
};

export default CartMobileOptionsItem;
